<template>
  <div class="indicators">
    <div class="container">
      <div class="sidebar">
        <div class="search-box">
          <input type="text" placeholder="搜索指标公式..." class="search-input" v-model="searchQuery">
          <button class="search-btn" @click="handleSearch">搜索</button>
        </div>
        <div class="category-list">
          <h3>指标分类</h3>
          <ul>
            <li class="category-item" :class="{ active: selectedCategory === '全部' }" @click="selectCategory('全部')">全部</li>
            <li class="category-item" :class="{ active: selectedCategory === 'VIP免费' }" @click="selectCategory('VIP免费')">VIP免费</li>
            <li class="category-item" :class="{ active: selectedCategory === '会员公式' }" @click="selectCategory('会员公式')">会员公式</li>
            <li class="category-item" :class="{ active: selectedCategory === '通达信' }" @click="selectCategory('通达信')">通达信</li>
            <li class="category-item" :class="{ active: selectedCategory === '同花顺' }" @click="selectCategory('同花顺')">同花顺</li>
            <li class="category-item" :class="{ active: selectedCategory === '大智慧' }" @click="selectCategory('大智慧')">大智慧</li>
          </ul>
        </div>
      </div>
      <div class="content">
        <div class="page-header">
          <h1>指标公式</h1>
          <p>精选优质指标公式，助您捕捉市场机会</p>
        </div>
        <div class="post-list">
          <div class="post-item" v-for="post in filteredPosts" :key="post.id">
            <div class="post-header">
              <h2 class="post-title"><router-link :to="{ name: 'post', params: { id: post.id } }" class="post-link">{{ post.title }}</router-link></h2>
              <span class="post-tag">{{ post.tag }}</span>
            </div>
            <div class="post-content">
              {{ post.content }}
            </div>
            <div class="post-meta">
              <span class="post-time">{{ post.time }}</span>
              <span class="post-views">{{ post.views }}</span>
            </div>
          </div>
        </div>
        <div class="pagination">
          <button class="page-btn">上一页</button>
          <button class="page-btn active">1</button>
          <button class="page-btn">2</button>
          <button class="page-btn">3</button>
          <button class="page-btn">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndicatorsView',
  data() {
    return {
      searchQuery: '',
      selectedCategory: '全部',
      posts: [
        {
          id: 1,
          title: 'VIP免费【妖股爆发 · 马跃龙腾】波段启动寻龙信号 无未来函数｜无加密｜主副图选股指标 含完整源码',
          tag: 'VIP免费',
          content: '核心特点：本指标包含1主图+1副图+1选股指标 无未来 无加密 含源码 适用于中短线，相对波段低位、启动位置，爆发捕捉牛股，寻龙捉妖！尤其擅长捕...',
          time: '2天前',
          views: '10VIP'
        },
        {
          id: 2,
          title: '会员公式🔥【尾盘蛰伏】缩量回调双阶段末期的静默启动信号 1主图+1副图+1选股指标',
          tag: '会员公式',
          content: '指标核心结构: 技术特征：本指标包括1主图+1副图+1选股指标源码 尾盘14:45分-14:55运行选股 信号少而精 无未来函数 无加密 指标...',
          time: '5天前',
          views: '68'
        },
        {
          id: 3,
          title: 'VIP免费通达信 金钻【2026金刀驸马】波段右侧战法 尾盘抄底思路 放量突破形态',
          tag: 'VIP免费',
          content: '一，核心思路：1.全套指标包括 1主图+1副图+1选股指标，指标源码 无未来函数，2.波段右侧战法、基于趋势、量能异动与均线位置构建信号，符合...',
          time: '1周前',
          views: '10VIP'
        },
        {
          id: 4,
          title: 'VIP免费通达信【游资擒妖】2026百大指标 首板起爆系统 不追高也能抓妖股',
          tag: 'VIP免费',
          content: '通达信【游资擒妖】2026百大指标 首板起爆系统 不追高也能抓妖股 只做长期盘整后的突破 核心优化版 副图+选股指标源码 指标设计初衷：为什么叫“...',
          time: '1周前',
          views: '10VIP'
        },
        {
          id: 5,
          title: 'VIP免费颜劼【一字无量选股器】某神光平台爆款 卖很多的指标',
          tag: 'VIP免费',
          content: '颜劼无量一字选股器，9:30之后选股，本指标不加密，源码分享',
          time: '1周前',
          views: '5VIP'
        }
      ]
    }
  },
  computed: {
    filteredPosts() {
      let result = [...this.posts];
      
      // 分类筛选
      if (this.selectedCategory !== '全部') {
        result = result.filter(post => post.tag === this.selectedCategory);
      }
      
      // 搜索筛选
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter(post => 
          post.title.toLowerCase().includes(query) || 
          post.content.toLowerCase().includes(query)
        );
      }
      
      return result;
    }
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = category;
    },
    handleSearch() {
      // 搜索逻辑已在computed中处理
    }
  }
}
</script>

<style lang="scss" scoped>
.indicators {
  padding: 20px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 250px;
  flex-shrink: 0;
}

.search-box {
  display: flex;
  margin-bottom: 30px;
  .search-input {
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    outline: none;
    &:focus {
      border-color: #1890ff;
    }
  }
  .search-btn {
    padding: 0 15px;
    background-color: #1890ff;
    color: #fff;
    border: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    &:hover {
      background-color: #40a9ff;
    }
  }
}

.category-list {
  h3 {
    font-size: 18px;
    margin-bottom: 15px;
    color: #333;
  }
  ul {
    list-style: none;
  }
  .category-item {
    padding: 10px 15px;
    margin-bottom: 5px;
    background-color: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: #e6f7ff;
    }
    &.active {
      background-color: #1890ff;
      color: #fff;
    }
  }
}

.content {
  flex: 1;
}

.page-header {
  margin-bottom: 30px;
  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  p {
    font-size: 16px;
    color: #666;
  }
}

.post-list {
  margin-bottom: 30px;
}

.post-item {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.post-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.post-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  flex: 1;
  margin-right: 15px;
  line-height: 1.4;
  .post-link {
    color: #333;
    text-decoration: none;
    &:hover {
      color: #1890ff;
      text-decoration: underline;
    }
  }
}

.post-tag {
  padding: 4px 12px;
  background-color: #f0f0f0;
  border-radius: 12px;
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.post-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.post-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #e8e8e8;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
  &.active {
    background-color: #1890ff;
    color: #fff;
    border-color: #1890ff;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    gap: 20px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .search-box {
    margin-bottom: 20px;
  }
  
  .category-list {
    h3 {
      font-size: 16px;
      margin-bottom: 10px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
    .category-item {
      margin-bottom: 0;
      white-space: nowrap;
    }
  }
  
  .page-header {
    h1 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
    }
  }
  
  .post-item {
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .post-title {
    font-size: 16px;
  }
  
  .post-content {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .indicators {
    padding: 10px 0;
  }
  
  .post-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .post-tag {
    align-self: flex-start;
  }
  
  .page-btn {
    padding: 6px 12px;
    font-size: 14px;
  }
}
</style>